import React, { ElementType } from 'react'
import { Icon } from '@iconify/react'
import Box from '@mui/material/Box'

interface IconifyProps {
  icon: ElementType | string
  width?: number
  sx?: Record<string, any>
  ref?: React.Ref<any>
  [key: string]: any
}

const Iconify: React.FC<IconifyProps> = ({ icon, width = 20, sx, ref, ...other }) => (
  <Box
    ref={ref}
    component={Icon as ElementType}
    className="component-iconify"
    icon={icon}
    sx={{ width, height: width, ...sx }}
    {...other}
  />
)

export default Iconify
